// A single collapsible help entry built on the native <details>/<summary>
// element. Native disclosure is keyboard-accessible and screen-reader friendly
// out of the box, and degrades gracefully without JavaScript — important for an
// audience with limited computational experience.
export default function Disclosure({ question, children }) {
  return (
    <details className="group rounded-lg border border-gold/20 bg-navy-mid/30 transition-colors open:border-gold/40">
      <summary className="flex cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 font-serif text-lg font-semibold text-cream [&::-webkit-details-marker]:hidden">
        <span>{question}</span>
        <svg
          className="h-5 w-5 flex-shrink-0 text-gold transition-transform duration-200 group-open:rotate-180"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 7.5 10 12.5 15 7.5" />
        </svg>
      </summary>
      <div className="space-y-3 px-5 pb-5 text-base leading-relaxed text-ink-secondary">
        {children}
      </div>
    </details>
  );
}
